var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"mx-auto my-10",attrs:{"max-width":"1200"}},[_c('v-card-text',[_c('h2',[_vm._v("Your project donation is successfully completed!")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }